export const accountStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
  PENDING: 3,
}
